import React, { useRef } from "react";
import { useFormik } from "formik";
import { Button } from "@design-system/Button/Button";
import { TextArea } from "@design-system/TextArea/TextArea";

import { useClientBulkActions } from "../../ClientBulkActions/useClientBulkActions";
import styles from "./NoteAction.module.scss";

interface NoteActionProps {
    inputPlaceholder: string;
    onSubmitCallback?: () => void;
}

interface FormSchema {
    value: string;
}

export const NoteAction: React.FC<NoteActionProps> = ({
    inputPlaceholder,
    onSubmitCallback,
}) => {
    const bulkActions = useClientBulkActions();
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const formik = useFormik<FormSchema>({
        initialValues: {
            value: "",
        },
        onSubmit: async ({ value }) => {
            await bulkActions.run({
                action: "note",
                value,
            });
            onSubmitCallback?.();
        },
    });

    // Handle Enter key to submit form
    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            formik.submitForm();
        }
    };

    return (
        <div className={styles.noteAction}>
            <form onSubmit={formik.handleSubmit}>
                <TextArea
                    size="xl"
                    name="value"
                    className={styles.noteTextarea}
                    placeholder={inputPlaceholder}
                    ref={textareaRef}
                    autoFocus
                    value={formik.values.value}
                    onChange={formik.handleChange}
                    onKeyDown={handleKeyDown}
                />

                <div className={styles.footer}>
                    <Button type="submit" variant="secondary" size="sm">
                        Submit
                    </Button>
                </div>
            </form>
        </div>
    );
};
